'use strict';

module.exports = require('./Trigger');


//////////////////
// WEBPACK FOOTER
// ./~/rc-trigger/lib/index.js
// module id = ./node_modules/rc-trigger/lib/index.js
// module chunks = 0